window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.eventNamespace
      ? 'focusin.' + options.eventNamespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }
    return cookieEnabled;
  },
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
    * _.defaultTo from lodash
    * Checks `value` to determine whether a default value should be returned in
    * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
    * or `undefined`.
    * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
    *
    * @param {*} value - Value to check
    * @param {*} defaultValue - Default value
    * @returns {*} - Returns the resolved value
    */
  defaultTo: function(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  },
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;
        var options = variant.options;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update query parameter in url without clearing others.
     *
     * https://stackoverflow.com/questions/5999118/add-or-update-query-string-parameter
     * @param key
     * @param value
     * @param url
     * @returns {*}
     */
    _updateQueryString: function(key, value, url) {
      if (!url) url = window.location.href;
      var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
        hash;

      if (re.test(url)) {
        if (typeof value !== 'undefined' && value !== null)
          return url.replace(re, '$1' + key + "=" + value + '$2$3');
        else {
          hash = url.split('#');
          url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
          if (typeof hash[1] !== 'undefined' && hash[1] !== null)
            url += '#' + hash[1];
          return url;
        }
      }
      else {
        if (typeof value !== 'undefined' && value !== null) {
          var separator = url.indexOf('?') !== -1 ? '&' : '?';
          hash = url.split('#');
          url = hash[0] + separator + key + '=' + value;
          if (typeof hash[1] !== 'undefined' && hash[1] !== null)
            url += '#' + hash[1];
          return url;
        }
        else
          return url;
      }
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = this._updateQueryString('variant', variant.id, window.location.href);
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);
/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

slate.Drawers = (function () {
	var Drawer = function (id, position, options) {
		var defaults = {
			close: '.js-drawer-close',
			open: '.js-drawer-open-' + position,
			openClass: 'js-drawer-open',
			dirOpenClass: 'js-drawer-open-' + position
		};

		this.$nodes = {
			parent: $('body, html'),
			page: $('#PageContainer'),
			moved: $('.is-moved-by-drawer')
		};

		this.config = $.extend(defaults, options);
		this.position = position;

		this.$drawer = $('#' + id);

		if (!this.$drawer.length) {
			return false;
		}

		this.drawerIsOpen = false;
		this.init();
	};

	Drawer.prototype.init = function () {
		$(this.config.open).on('click', $.proxy(this.open, this));
		this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
	};

	Drawer.prototype.open = function (evt) {

		// Keep track if drawer was opened from a click, or called by another function
		var externalCall = false;

		// Prevent following href if link is clicked
		if (evt) {
			evt.preventDefault();
		} else {
			externalCall = true;
		}

		// Without this, the drawer opens, the click event bubbles up to $nodes.page
		// which closes the drawer.
		if (evt && evt.stopPropagation) {
			evt.stopPropagation();
			// save the source of the click, we'll focus to this on close
			this.$activeSource = $(evt.currentTarget);
		}

		/*if (this.drawerIsOpen && !externalCall) {
			return this.close();
		}*/

		// Notify the drawer is going to open
		slate.cache.$body.trigger('beforeDrawerOpen.slate', this);

		// Add is-transitioning class to moved elements on open so drawer can have
		// transition for close animation
		this.$nodes.moved.addClass('is-transitioning');
		this.$drawer.prepareTransition();

		this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
		this.drawerIsOpen = true;

		// Set focus on drawer
		this.trapFocus(this.$drawer, 'drawer_focus');

		// Run function when draw opens if set
		if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
			if (!externalCall) {
				this.config.onDrawerOpen();
			}
		}

		if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
			this.$activeSource.attr('aria-expanded', 'true');
		}

		// Lock scrolling on mobile
		this.$nodes.page.on('touchmove.drawer', function () {
			return false;
		});

		this.$nodes.page.on('click.drawer', $.proxy(function () {
			this.close();
			return false;
		}, this));

		// Notify the drawer has opened
		slate.cache.$body.trigger('afterDrawerOpen.slate', this);

		if(this.drawerIsOpen) {
			var $overlay = $('#DrawerOverlay');
			$overlay.css({top: window.scrollY + 'px'});
			$overlay.fadeIn();
			$overlay.on('click', function() {
				$overlay.fadeOut();
				slate.RightDrawer.close();
				slate.RightDrawer.drawerIsOpen = false;
			});
			$(document).on('scroll', function() {
				if(slate.RightDrawer.drawerIsOpen) {
					event.preventDefault();
				}
			});
			$(window).on('resize', function() {
				if(slate.RightDrawer.drawerIsOpen) {
					$overlay.css({top: window.scrollY + 'px'});
				}
			})
		}
	};

	Drawer.prototype.close = function () {
		if (!this.drawerIsOpen) { // don't close a closed drawer
			return;
		}

		// Notify the drawer is going to close
		slate.cache.$body.trigger('beforeDrawerClose.slate', this);

		// deselect any focused form elements
		$(document.activeElement).trigger('blur');

		// Ensure closing transition is applied to moved elements, like the nav
		this.$nodes.moved.prepareTransition({ disableExisting: true });
		this.$drawer.prepareTransition({ disableExisting: true });

		this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

		this.drawerIsOpen = false;

		// Remove focus on drawer
		this.removeTrapFocus(this.$drawer, 'drawer_focus');

		this.$nodes.page.off('.drawer');

		// Notify the drawer is closed now
		slate.cache.$body.trigger('afterDrawerClose.slate', this);
	};

	Drawer.prototype.trapFocus = function ($container, eventNamespace) {
		var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

		$container.attr('tabindex', '-1');

		$container.focus();

		$(document).on(eventName, function (evt) {
			if ($container[0] !== evt.target && !$container.has(evt.target).length) {
				$container.focus();
			}
		});
	};

	Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
		var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

		$container.removeAttr('tabindex');
		$(document).off(eventName);
	};

	return Drawer;
})();

slate.RightDrawer = new slate.Drawers('CartDrawer', 'right', {
	'onDrawerOpen': ajaxCart.load
});

$(document).ready(function() {
	slate.cacheSelectors();
	ajaxCart.init();
	ajaxCart.load();
});
/*============================================================================
 Money Format
 - Shopify.format money is defined in option_selection.js.
 If that file is not included, it is redefined here.
 ==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
	Shopify.formatMoney = function(cents, format) {

		var value = '',
			placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
			formatString = (format || this.money_format);

		if (typeof cents == 'string') {
			cents = cents.replace('.','');
		}

		function defaultOption(opt, def) {
			return (typeof opt == 'undefined' ? def : opt);
		}

		function formatWithDelimiters(number, precision, thousands, decimal) {
			precision = defaultOption(precision, 2);
			thousands = defaultOption(thousands, ',');
			decimal   = defaultOption(decimal, '.');

			if (isNaN(number) || number == null) {
				return 0;
			}

			number = (number/100.0).toFixed(precision);

			var parts   = number.split('.'),
				dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
				cents   = parts[1] ? (decimal + parts[1]) : '';

			return dollars + cents;
		}

		/*
		switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
		}*/

		return '$' + formatWithDelimiters(cents, 0);
	}
}

slate.cacheSelectors = function () {
	slate.cache = {
		// General
		$html                    : $('html'),
		$body                    : $(document.body),

		// Navigation
		$navigation              : $('#AccessibleNav'),
		$mobileSubNavToggle      : $('.mobile-nav__toggle'),

		// Collection Pages
		$changeView              : $('.change-view'),

		// Product Page
		$productImage            : $('#ProductPhotoImg'),
		$thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

		// Customer Pages
		$recoverPasswordLink     : $('#RecoverPassword'),
		$hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
		$recoverPasswordForm     : $('#RecoverPasswordForm'),
		$customerLoginForm       : $('#CustomerLoginForm'),
		$passwordResetSuccess    : $('#ResetSuccess')
	};
};
slate.productPage = function (options) {
	var moneyFormat = options.money_format,
		variant = options.variant,
		selector = options.selector;

	// Selectors
	var $productImage = $('#ProductPhotoImg'),
		$addToCart = $('#AddToCart'),
		$productPrice = $('#ProductPrice'),
		$comparePrice = $('#ComparePrice'),
		$quantityElements = $('.quantity-selector, label + .js-qty'),
		$addToCartText = $('#AddToCartText');

	if (variant) {

		// Update variant image, if one is set
		if (variant.featured_image) {
			var newImg = variant.featured_image,
				el = $productImage[0];
			Shopify.Image.switchImage(newImg, el, timber.switchImage);
		}

		// Select a valid variant if available
		if (variant.available) {
			// Available, enable the submit button, change text, show quantity elements
			$addToCart.removeClass('disabled').prop('disabled', false);
			$addToCartText.html('Add to cart');
			$quantityElements.show();
		} else {
			// Sold out, disable the submit button, change text, hide quantity elements
			$addToCart.addClass('disabled').prop('disabled', true);
			$addToCartText.html('Pre-order');
			$quantityElements.hide();
		}

		// Regardless of stock, update the product price
		$productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

		// Also update and show the product's compare price if necessary
		if (variant.compare_at_price > variant.price) {
			$comparePrice
				.html('$' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
		.show();
		} else {
			$comparePrice.hide();
		}

	} else {
		// The variant doesn't exist, disable submit button.
		// This may be an error or notice that a specific variant is not available.
		// To only show available variants, implement linked product options:
		//   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
		$addToCart.addClass('disabled').prop('disabled', true);
		$addToCartText.html('Unavailable');
		$quantityElements.hide();
	}
};

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function() {
  console.log('product fired');
  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    variantSelected: '[data-selected-variant]',
    zipMoneyOpen: '[data-open-zipmoney-modal]',
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    this.settings = {};
    this.namespace = '.product';

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      $(selectors.productJson, this.$container).html()
    );
    this.settings.imageSize = slate.Image.imageSize(
      $(selectors.productFeaturedImage, this.$container).attr('src')
    );

    slate.Image.preload(
      this.productSingleObject.images,
      this.settings.imageSize
    );

    this.initVariants();
  }

  Product.prototype = $.extend({}, Product.prototype, {
    /**
     * Handles change events from the variant inputs
     */
    initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: true,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject,
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        'variantChange' + this.namespace,
        this.updateAddToCartState.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.namespace,
        this.updateProductImage.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.namespace,
        this.updateProductPrices.bind(this)
      );

      this.initZipMoney();
      this.initDropdown();
      // this.initColorSelector();
    },

    /**
     * Zip money modal
	   */
    initZipMoney: function() {
      var $zipOpen = $(selectors.zipMoneyOpen);
      var $zipModal = $('#zip-money__modal');

      $zipOpen.on('click', function() {
        $zipModal.modal({
          fadeDuration: 250,
          fadeDelay: 0,
        });
      });
    },

    /**
     * Creates the custom dropdown box for displaying sizes.
     */
    initDropdown: function() {
      $(document).on('click', '.variant-selected', function(event) {
        var parent = $(this).parents('.variant-dropdown-wrapper');
        if ($(this).hasClass('variant-changing')) {
          $(this).removeClass('variant-changing');
          parent.find('.variant-dropdown').slideUp(200);
        } else {
          $(this).addClass('variant-changing');
          parent.find('.variant-dropdown').slideDown(200);
        }
      });

      $('.variant-select').on('click', function(event) {
        $('.variant-dropdown').slideUp(200);
        var title = $(this).children('.variant-title').html();
        var size = $(this).children('.variant-size').html();
        var parent = $(this).parents('.variant-dropdown-wrapper');
        parent.find('.variant-selected .variant-text').fadeOut(function() {
          parent.find('.variant-selected .variant-title').html(title);
          parent.find('.variant-selected .variant-size').html(size);
          parent.find(selectors.singleOptionSelector).val(title).change();
          $(this).parent().removeClass('variant-changing');
          $(this).fadeIn();
        });

        // Facebook pixel tracking per session
        var shopifySession = localStorage.getItem('_shopify_y');
        var facebookPixelSession = localStorage.getItem('_fbPixel_session');

        if (facebookPixelSession !== shopifySession) {
          localStorage.setItem('_fbPixel_session', shopifySession);
          window.fbq('trackCustom', 'SIZE_SELECTED');
        }
      });
    },

    /**
     * Creates the custom dropdown box for displaying sizes.
     */
    initColorSelector: function() {
      $('.variant-color-select').on('click', function(event) {
        var colorSelected = event.target.attributes['data-color'].value;

        $(selectors.colorSelector).val(colorSelected).change();
        $('.variant-color__info_selected').html(colorSelected);
      });
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabeled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(
          theme.strings.unavailable
        );
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(
          theme.strings.addToCart
        );
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(
        selectors.comparePriceText,
        this.$container
      );

      $(selectors.productPrice, this.$container).html(
        slate.Currency.formatMoney(variant.price, theme.moneyFormat)
      );

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(
          slate.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(
        variant.featured_image.src,
        this.settings.imageSize
      );

      $(selectors.productFeaturedImage, this.$container).attr(
        'src',
        sizedImgUrl
      );
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    },
  });

  return Product;
})();

var selectCallback = function(variant, selector) {
  slate.productPage({
    money_format: '${{amount_no_decimals}}',
    variant: variant,
    selector: selector,
  });
};

$(document).ready(function() {
  if (window.location.href.indexOf('/products/koala-sheets') > -1) {
    $('.site-nav__link[href$="products/koala-mattress"]').each(function() {
      if (this.innerHTML === 'Buy Now') {
        if (!window.location.origin) {
          window.location.origin =
            window.location.protocol +
            '//' +
            window.location.hostname +
            (window.location.port ? ':' + window.location.port : '');
        }
        this.href = window.location.origin + '/products/koala-sheets';
      }
    });
  }
});

$(document).ready(function() {
    //$('.fancybox').fancybox();
    $('.review-slider__reviews').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3500,
        responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
});
$(document).ready(function() {

    $('[data-open-comparison]').on('click', function() {
        $('#comparison').modal({
            fadeDuration: 250
        })
    })


});
$(document).ready(function() {

  var container = 'particles';
  if(document.getElementById('particles')) {
	  particlesJS.load(container, 'https://cdn.shopify.com/s/files/1/1890/5525/t/4/assets/particlesjs-config.json?cache=' + new Date(), function () {
	  });
  }

});
$(document).ready(function() {
  $('[data-open-modal-nav]').on('click', function() {
    var $modalNav = $('#modal-nav');

    $modalNav.modal({
      showClose: false,
      fadeDuration: 250,
      fadeDelay: 0,
    });

    $modalNav.on($.modal.BEFORE_OPEN, function(event, modal) {
      modal.$blocker.addClass('modal-nav__fix-height');
    });
  });

  $('[data-close-modal-nav]').on('click', function() {
    $.modal.close();
  });

  $('[data-open-cart]').on('click', function(event) {
    slate.RightDrawer.open(event);
  });

  $('a[href="/products/koala-mattress"]').on('click', function(event) {
    if (window.location.href.indexOf('/products/koala-mattress') > -1) {
      $('html, body').animate({ scrollTop: 0 }, 'slow');
      $.modal.close();
      event.preventDefault();
    }
  });

  $('.site-nav__link[href$="products/koala-sheets"]').on('click', function(
    event
  ) {
    if (window.location.href.indexOf('/products/koala-sheets') > -1) {
      $('html, body').animate({ scrollTop: 0 }, 'slow');
      $.modal.close();
      event.preventDefault();
    }
  });

  $('[data-btn-lang]').on('click', function(event) {
    var $langs = $('.modal-country__selector');
    var active = $langs.hasClass('lang-in');
    $langs.removeClass(active ? 'lang-in' : 'lang-out');
    $langs.addClass(active ? 'lang-out' : 'lang-in');
  });
});

$(document).ready(function () {

	var scrollMagic;

	function initScrollMagic() {
		var controller = new ScrollMagic.Controller();
		var scenes = [];

		function aboutDelivery() {
			if ($('.about-delivery') && !xsmallScreen()) {
				var tweenTitle = new TweenMax.staggerFromTo(
					".about-delivery__title",
					2,
					{transform: 'translateY(300px)'},
					{transform: 'translateY(0)'},
					0.15
				);
				var sceneTitle = new ScrollMagic.Scene({
					triggerElement: '.about-delivery',
					duration: 300,
				}).setTween(tweenTitle)
				//.addIndicators()
					.addTo(controller);
				var tweenBox = new TweenMax.staggerFromTo(
					".about-delivery__img-box",
					2,
					{transform: 'translateY(0)'},
					{transform: 'translateY(50px)'},
					0.15
				);
				var sceneBox = new ScrollMagic.Scene({
					triggerElement: '.about-delivery',
					duration: 300,
				}).setTween(tweenBox)
				//.addIndicators()
					.addTo(controller);

				scenes.push(sceneTitle);
				scenes.push(sceneBox);
			} else if (xsmallScreen()) {
			  $('.about-delivery__img-box').css({
          transform: 'translateY(50px)'
        })
      }
		}

		function rejoiceBed() {
			if ($('.technology__img-bed')) {
			  if(!smallScreen()) {
          var tween = new TweenMax.staggerFromTo(
            '.technology__img-bed',
            2,
            {transform: 'translateY(0px)', opacity: 0},
            {transform: 'translateY(-80px)', opacity: 1},
            0
          );
          var scene = new ScrollMagic.Scene({
            triggerElement: '.rejoice',
            triggerHook: 'onCenter',
            offset: 200,
            duration: 300,
          }).setTween(tween)
            .addTo(controller);
          scenes.push(scene);
        } else if(xsmallScreen()) {
          $('.technology__img-bed').css({'transform': 'translateY(-55px)'});
        } else {
          $('.technology__img-bed').css({'transform': 'translateY(-80px)'});
        }
			}
		}

		function mattressBlowup() {

			(function arrows() {
				if ($('.mattress-blowup__diagram.arrows') && !smallScreen()) {
					var tweenBlowupArrows = new TimelineMax()
						.to('.mattress-blowup__diagram.arrows', 2.5, {
							alpha: 0,
							repeatDelay: .5,
							repeat: -1,
							y: '-300px'
						})
					var sceneBlowupArrows = new ScrollMagic.Scene({
						triggerElement: '.mattress-parallax__left',
						duration: 400
					})
						.setPin('.mattress-blowup__diagram.arrows', {pushFollowers: false})
						//.addIndicators({ name: 'blowupArrows' })
						.addTo(controller)
						.on('start', function () {
							tweenBlowupArrows.play();
						});
				}
			})();

			(function top() {
				if ($('.mattress-blowup__diagram.top') && !smallScreen()) {
					var tween = {
						element: '.mattress-blowup__diagram.top',
						curviness: 1.25,
						autoRotate: true,
						values: [
							{y: '-8px'},
							{y: '8px'},
							{y: '0px'},
						]
					}
					var timeline = new TimelineMax() // Loops arrow up and down.
						.add(TweenMax.to(tween.element, 5, {css: {bezier: tween}, repeatDelay: 0, repeat: -1}));
				}
			})();

			(function cover() {
				if ($('.mattress-blowup__diagram.cover') && !smallScreen()) {
					var tweenBlowupCover = new TweenMax.staggerFromTo(
						'.mattress-blowup__diagram.cover',
						2,
						{x: '-190px'},
						{x: '190px'},
						0.15
					);
					var tweenBlowupCover = new ScrollMagic.Scene({
						triggerElement: '.mattress-blowup__diagram.cover',
						duration: 300,
						offset: -60
					}).setTween(tweenBlowupCover)
					//.addIndicators({ name: 'cover' })
						.addTo(controller);
				}
			})();

		}

		aboutDelivery();
		rejoiceBed();
		//mattressBlowup();

		return {
			destroy: function () {
				controller.destroy(true);
			}
		}
	}

  function smallScreen() {
    var screenWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    return screenWidth < 992;
  }

  function xsmallScreen() {
    var screenWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    return screenWidth < 420;
  }

	$(window).resize(function () {
		scrollMagic && scrollMagic.destroy();
		scrollMagic = undefined;
    scrollMagic = initScrollMagic();
	});

	scrollMagic = initScrollMagic();

});

$(document).ready(function() {

	var $toggles = $('.toggle, .product-toggle');

	$toggles.on('click', function() {
		var $info = $(this).find('.toggle-info');
		var visible = $info.hasClass('active');
		if(visible) {
			$info.removeClass('active');
			$info.removeClass('animate-in');
			$info.addClass('animate-out');
		} else {
			$info.addClass('active');
			$info.removeClass('animate-out');
			$info.addClass('animate-in');
		}
	});

});

$(document).ready(function() {
	$form = $('#mc-embedded-subscribe-form').on('submit', function(event) {

		window.fbq('trackCustom', 'Newsletter Signup');
		var data = $(this).serializeArray();
		var $alert = $form.find('.alert');
		console.log('form data:', data);
		event.preventDefault();
		$.ajax({
			type: 'post',
			dataType: 'json',
			contentType: 'application/json; charset=utf-8',
			url: '//koala.us15.list-manage.com/subscribe/post-json?u=573ad43cd661313822709c4c7&id=f405e9812a&c=?',
			data: data,
			cache: false,
			success: function(resp) {
				console.log('success', resp);
				if(resp.result == 'error') {
					$alert.html(resp.msg);
					$alert.addClass('error');
					$alert.fadeIn();
				} else if(resp.result == 'success') {
					$alert.fadeOut(function() {
						$alert.html(resp.msg);
						$('#mc_embed_signup_scroll').fadeOut(function() {
							$alert.addClass('success');
							$alert.fadeIn();
              dataLayer.push({
                'event' : 'newslettersignup'
              });
						});
					})
				}
			},
			error: function(error) {
				$alert.html(error);
				$alert.addClass('error');
				$alert.fadeIn();
			}
		})
	});
});

$(document).ready(function() {
  $('.js-drawer-close').on('click', function() {
    $('#DrawerOverlay').hide();
  });
});

$(document).ready(function() {
  $('.mattress-specs-btn').click(function() {
    $('.info').slideToggle('slow', 'swing', function() {});
  });
});

/*function getCart() {
  return new Promise((resolve, reject) => {
    var request = new XMLHttpRequest();
    request.open('GET', '/cart.js', true);

    request.onreadystatechange = () => {
      if (request.readyState === XMLHttpRequest.DONE) {
        if (request.status >= 200 && request.status < 400) {
          resolve(request.responseText);
        } else {
          reject(request.status);
        }
      }
    };

    request.onerror = () => {
      reject(request.statusText);
    };

    request.send();
  });
}

$(document).ready(function() {
  $('#duvet-select').on('click', event => {
    // Debug only.
    getCart().then(x => console.info(x));
  });
});
*/

$(document).ready(function() {

  var debug = false;

  var check = setInterval(function() {
    if(window.dataLayer) {
      var $sizeSelect = $('.variant-select');
      if($sizeSelect) {
        $sizeSelect.on('click', function(event) {
          window.dataLayer.push({
            'event' : 'sizeselect'
          });
          window.pintrk('size-select');
          if (debug) console.info('Fired: sizeselect');
        });
      }

      var $addToCart = $('.product__btn-buy');
      if($addToCart) {
        $addToCart.on('click', function(event) {
          window.dataLayer.push({
            'event' : 'addtocart'
          });
          window.pintrk('add-to-cart');
          if (debug) console.info('Fired: addtocart');
        });
      }

      if(debug) {
        console.log('dataLayer', dataLayer);
      }

      clearInterval(check);
    } else if(debug) {
      console.error('dataLayer not found. Event based tracking disabled.')
    }
  }, 1000);


});

$.getUrlVar = function(key){
  var result = new RegExp(key + "=([^&]*)", "i").exec(window.location.search);
  return result && unescape(result[1]) || "";
};

$(document).ready(function() {

  var paramCode = $.getUrlVar('fc');
  var paramDiscount = $.getUrlVar('fd')

  if (paramCode) {
    if (!paramDiscount) {
      console.log('Coupon found but no discount was passed through.');
    } else {
      var deal = {
        code: paramCode,
        discount: paramDiscount
      };
      $('a').each(function() {
        var href = $(this).attr('href');

        if (href) {
          if(href.indexOf('/') == 0 || href.indexOf('koala.com') > -1) {
            href += (href.match(/\?/) ? '&' : '?') + 'fc=' + deal.code + '&fd=' + deal.discount;
            $(this).attr('href', href);
          }
        }
      });
    }
  };
})


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  /* AS 20170601  want to access the slate objects elsewhere sometimes */
  $('html').data('slate__sections', sections);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace(
      'supports-no-cookies',
      'supports-cookies'
    );
  }

  // Header Fix for promo banner.
  var checkBounceX = setInterval(function() {
    var $header = $('#shopify-section-site-header');
    var $bouncex = $('#bx-campaign-434669');

    if ($bouncex.length) {
      $header.css({
        top: '75px',
      });
      clearInterval(checkBounceX);
    }
  }, 400);
});
